<template>
  <div class="h-user-sell-list">

    <div class="sell-list-header h-outer-border around-4 bw2 bz0 h-bg brown-2">
      <div class="artifact">物品</div>
      <div class="gold">售价</div>
      <div class="amount w60">数量</div>
      <div class="amount w60">剩余</div>
      <div class="end-time w120">结束时间</div>
      <div class="status">状态</div>
      <div class="extractable-gold">可提取</div>
      <div class="misc w130"></div>
    </div>
    <div class="sell-list">
      <div class="empty" v-if="!sellList.length">暂无寄卖物品</div>
      <div class="sell-item h-outer-border around-4 bw2 bz0 h-bg brown-2"
           v-for="item in sellList">
        <HArtifact :size="40" :artifact="item"></HArtifact>
        <div class="table-td">
          {{ item.gold }}
        </div>
        <div class="table-td base-amount w60">
          {{ item.baseAmount }}
        </div>
        <div class="table-td amount w60" :class="{ gray: item.amount <= 0 }">
          {{ item.amount }}
        </div>
        <div class="table-td end-time w120" :class="{ gray: item.isEnd }">
          {{ item.endDate | dateFormat }}
        </div>
        <div class="table-td status" :class="[item.status]">
          {{ item.statusText }}
        </div>
        <div class="table-td extractable-gold" :class="{ gray: !item.extractableGold }">
          {{ item.extractableGold }}
        </div>
        <div class="table-td misc w130">
          <button class="h-btn normal" :disabled="!item.extractableGold" v-click-sound-button
                  @click="handleExtractGold(item)">
            <span>提取金币</span>
          </button>
          <button class="h-btn normal" :disabled="!item.cancelable" v-click-sound-button
                  @click="handleCancelSell(item)">
            <span>取回物品</span>
          </button>
        </div>
      </div>
    </div>

    <HPager :page="pager.page" :pageSize="pager.pageSize" :total="pager.total" @pageChange="handlePageChange"></HPager>

    <BuyPopup v-if="buyPopupShow" :itemInfo="buyItemInfo" @close="buyPopupShow=false"
              @refresh="handleRefresh"></BuyPopup>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import HArtifact from '@/components/h-artifact/index'
  import HPager from '@/components/base/h-pager/index'
  import BuyPopup from './buy-popup'
  import API from '@js/api'
  import DateFormat from '@js/date-format'

  export default {
    name: 'sell-list',

    filters: {
      dateFormat (v) {
        return DateFormat(v, 'YYYY-MM-DD hh:mm')
      }
    },

    data () {
      return {
        sellList: [],
        buyItemInfo: null,
        buyPopupShow: false,
        pager: {
          page: 0,
          pageSize: 5,
          total: 0,
        },
        loading: false,
      }
    },

    computed: {
      ...mapGetters('user', [
        'userId',
      ]),

      ...mapGetters('hero', [
        'gold',
        'backpackItems',
      ]),

      list () {
        return this.backpackItems.filter((d) => {
          return ![105, 201, 202, 301, 407, 503, 504].includes(d.artifactId)
        })
      },

    },

    mounted () {
      this.getUserSellList()
    },

    methods: {
      ...mapActions('hero', [
        'getGold',
      ]),

      async getUserSellList () {
        try {
          const { list, count } = await API.market.getUserSellList({
            page: this.pager.page,
            pageSize: this.pager.pageSize,
          })
          list.forEach((d) => {
            if (!d.amount) {
              d.statusText = '已售出'
              d.status = 'sold-out'
            } else if (d.isEnd) {
              d.statusText = '已结束'
              d.status = 'time-end'
            } else {
              d.statusText = '出售中'
              d.status = 'selling'
            }
            d.cancelable = d.amount > 0
          })
          this.pager.total = count
          this.sellList = list
        } catch (err) {
          console.error(err)
          this.$message(err)
        }
      },

      handleBuy (item) {
        this.buyItemInfo = JSON.parse(JSON.stringify(item))
        this.buyPopupShow = true
      },

      handleRefresh () {
        this.getGold()
        this.getUserSellList()
      },

      handlePageChange (page) {
        this.pager.page = page
        this.getUserSellList()
      },

      async handleExtractGold (item) {
        try {
          if (this.loading) {
            return
          }

          this.loading = true
          const confirm = await this.$confirm(`即将提取金币，请确认。`)
          if (!confirm) {
            return
          }
          await API.market.extractGold({
            id: item.id,
          })
          this.$message('金币已提取。')
          this.getUserSellList()
          this.getGold()
        } catch (err) {
          console.error(err)
          this.$message(err)
        } finally {
          this.loading = false
        }
      },

      async handleCancelSell (item) {
        try {
          if (this.loading) {
            return
          }
          this.loading = true
          const confirm = await this.$confirm(`即将取回【${item.nameCn}】，请确认。`)
          if (!confirm) {
            return
          }
          await API.market.cancelSell({
            id: item.id,
          })
          this.$message('物品已取回。')
          this.getUserSellList()
        } catch (err) {
          console.error(err)
          this.$message(err)
        } finally {
          this.loading = false
        }
      },

    },

    components: {
      HArtifact,
      BuyPopup,
      HPager,
    },
  }
</script>

<style lang="stylus" scoped>
  .sell-list-header
    margin-bottom 2px
    display flex
    padding 5px 2px
    line-height 16px
    font-size 12px
    letter-spacing 1px
    text-align center
    goldText1()
    > div
      width 100px
    .artifact
      width 40px

  .empty
    padding-top 10px
    line-height 20px
    text-align center
    font-size 12px
    letter-spacing 1px
    whiteText1()

  .sell-list
    height 245px

  .sell-item
    display flex
    padding 2px
    &:not(:last-child)
      margin-bottom 5px
    > div
      flex-shrink 0
    .table-td
      display flex
      justify-content center
      align-items center
      width 100px
      font-size 12px
      letter-spacing 1px
      whiteText1()
    .misc
      justify-content flex-end
      .h-btn
        width 51px
        height 24px
        line-height 24px
        font-size 12px
        > span
          display block
          transform-origin center
          transform scale(0.75)
          white-space nowrap
        &:not(:last-child)
          margin-right 5px
    .status.time-end
      color $colorRed1
    .status.sold-out
      color rgba(255, 255, 255, 0.5)
    .status.selling
      color $colorLightBlue

  .gray
    color rgba(255, 255, 255, 0.5) !important

  .w60
    width 60px !important

  .w80
    width 80px !important

  .w100
    width 100px !important

  .w120
    width 120px !important

  .w130
    width 130px !important
</style>
